import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { FiMenu, FiX, FiSearch, FiShield } from 'react-icons/fi';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const navItems = [
    { name: 'News', path: '/news' },
    { name: 'Safety Alerts', path: '/alerts' },
    { name: 'Product Database', path: '/products' },
    { name: 'Resources', path: '/resources' },
    { name: 'About', path: '/about' },
  ];

  return (
    <header className="bg-white border-b border-gray-200 sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2">
            <div className="bg-primary text-white p-2 rounded-lg">
              <FiShield size={24} />
            </div>
            <div className="flex flex-col">
              <span className="text-xl font-bold text-primary-dark leading-none tracking-tight">RECALL MORINGA</span>
              <span className="text-xs text-news-muted font-medium tracking-wider uppercase">Safety Reporting Center</span>
            </div>
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8">
            {navItems.map((item) => (
              <NavLink
                key={item.name}
                to={item.path}
                className={({ isActive }) =>
                  `font-medium transition-colors hover:text-primary ${
                    isActive ? 'text-primary border-b-2 border-primary' : 'text-gray-600'
                  }`
                }
              >
                {item.name}
              </NavLink>
            ))}
            <button className="text-gray-500 hover:text-primary transition-colors">
              <FiSearch size={20} />
            </button>
            <Link to="/alerts" className="bg-primary hover:bg-primary-dark text-white px-5 py-2 rounded-full font-medium transition-colors text-sm">
              Report Issue
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-gray-700"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? <FiX size={28} /> : <FiMenu size={28} />}
          </button>
        </div>
      </div>

      {/* Mobile Nav */}
      {isOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 absolute w-full shadow-lg">
          <div className="flex flex-col p-4 gap-4">
            {navItems.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                className="text-lg font-medium text-gray-700 py-2 border-b border-gray-50"
                onClick={() => setIsOpen(false)}
              >
                {item.name}
              </Link>
            ))}
            <Link 
              to="/alerts" 
              className="mt-2 bg-primary text-center text-white py-3 rounded-lg font-bold"
              onClick={() => setIsOpen(false)}
            >
              Report a Safety Issue
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;